module.exports = __webpack_public_path__ + "static/media/2-Y.5afbb345.mp3";